import React from 'react';

import MainFooter from './MainFooter';

export default function About({ name }) {
  return (
    <div className="App">
      <div>
        <title>BEN VEGEL - ABOUT WEBSITE</title>
        <meta name="description" content="Thank you for visiting www.benvegel.com and welcome to the current web application..." />

        <div class = "wrapper">
          <h1>WEBSITE</h1>
          
          <div>
            <p>CODED BY BEN VEGEL</p>
            <p>IN UTAH</p>
            <p>UNITED STATES</p>
          </div>

          <div class = "video-zaviti">
            <div class = "zaviti-urejeno-video">
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/TnoMS5n_B0c" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen title = "NAOMI PEAK MOUNTAIN TRAIL HIKING"></iframe>
            </div>
          </div>

          <div>
            <p>VERSION 1.2.5 RELEASED 10/7/2026</p>
            <p>POWERED BY REACT</p>
            <p>cryptography@benvegel.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}
